import { Grid, IconButton, Tab, Tabs, styled, useTheme } from "@mui/material";
import { Link, useSearchParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { TRADE_HISTORY_TABS, WALLET_TYPE } from "../constants";
import {
  getMarginOpenOrderList,
  getMarginTradeLast24HList,
  getSpotOpenOrderList,
  getSpotTradeLast24HList,
} from "store/slices/trade/tradeSlice";

import { History } from "assets/Icon";
import History24Log from "./Components/History24Log";
import OpenOrderHistory from "./Components/OpenOrderHistory";
import useDispatch from "hooks/useDispatch";

function TradeHistory({ onCancelOrder }) {
  const theme = useTheme();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();

  const tradeHistoryTab = +searchParams.get("tradeHistoryTab") || 0;
  const walletTypeId = +searchParams.get("walletTypeId") || 1;
  const pageNumber = searchParams.get("page") || 1;
  const pageSize = searchParams.get("perPage") || 10;

  const handleChange = (_, newValue) => {
    const allSearchParams = Object.fromEntries([...searchParams]);

    setSearchParams({
      ...allSearchParams,
      tradeHistoryTab: newValue,
    });
  };

  const getInitialTradeHistory = async () => {
    setLoading(true);
    if (walletTypeId === WALLET_TYPE.margin) {
      if (tradeHistoryTab === TRADE_HISTORY_TABS.openOrder) {
        await dispatch(
          getMarginOpenOrderList({
            coinSourceId: -1,
            coinDestinationId: -1,
            sideId: 0,
            typeId: 0,
            pageNumber,
            pageSize,
          })
        );
      } else {
        await dispatch(getMarginTradeLast24HList());
      }
    } else {
      if (tradeHistoryTab === TRADE_HISTORY_TABS.openOrder) {
        await dispatch(
          getSpotOpenOrderList({
            coinSourceId: -1,
            coinDestinationId: -1,
            sideId: 0,
            typeId: 0,
            pageNumber,
            pageSize,
          })
        );
      } else {
        await dispatch(getSpotTradeLast24HList());
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    getInitialTradeHistory();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [walletTypeId, tradeHistoryTab]);

  return (
    <Grid container mt={2}>
      <TabWrapper item xs={12}>
        <TabsStyle value={tradeHistoryTab} onChange={handleChange}>
          <Tab label="24H Log" value={0} />
          <Tab label="Open Order" value={1} />
        </TabsStyle>

        <IconButton
          component={Link}
          to={"/history/trade-history?tradeTab=1&walletTypeId=0&page=1"}
        >
          <History color={theme.palette.secondary.main} />
        </IconButton>
      </TabWrapper>

      <Grid item xs={12}>
        {tradeHistoryTab === 0 && <History24Log loading={loading} />}
        {tradeHistoryTab === 1 && (
          <OpenOrderHistory
            onCancel={onCancelOrder}
            loading={loading}
            getInitialTradeHistory={getInitialTradeHistory}
          />
        )}
      </Grid>
    </Grid>
  );
}

const TabWrapper = styled(Grid)(({ theme }) => ({
  marginTop: theme.spacing(3),
  borderBottom: `1px solid ${theme.palette.modules.border}`,
  marginBottom: theme.spacing(3),

  display: "flex",
  alignItems: "flex-end",
  justifyContent: "space-between",
}));

const TabsStyle = styled(Tabs)(({ theme }) => ({
  margin: "initial",

  ".MuiTabs-flexContainer": {
    justifyContent: "flex-start",

    ".MuiButtonBase-root": {
      marginRight: theme.spacing(4),
    },
  },
}));

export default TradeHistory;
